import { render, staticRenderFns } from "./GameUnavailable.vue?vue&type=template&id=a43f8468&scoped=true&"
import script from "./GameUnavailable.vue?vue&type=script&lang=ts&"
export * from "./GameUnavailable.vue?vue&type=script&lang=ts&"
import style0 from "./GameUnavailable.vue?vue&type=style&index=0&id=a43f8468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43f8468",
  null
  
)

export default component.exports